import type { TOC } from '@ember/component/template-only';
import { PrismDataBar } from '@mylighthouse/prism-ember';
import type {
  BarData,
  SymmetryData,
} from '@mylighthouse/prism-ember/types/components/prism/data-bar';
import { gt, lt } from 'ember-truth-helpers';
import HotelAndMarketRevenueInsightSegmentationSegmentationItemCurrentValue from 'lumen/components/hotel-and-market/revenue-insight/segmentation/segmentation-item-current-value';
import type { RevenueInsightSegmentationValue } from 'lumen/models';

interface HotelAndMarketRevenueInsightSegmentationSegmentationItemWithChangeSignature {
  Args: {
    activateSearch: () => void;
    changeData: SymmetryData;
    hasTarget?: boolean;
    isBudgetActive?: boolean;
    isForecastActive?: boolean;
    isStriped?: boolean;
    item: RevenueInsightSegmentationValue;
    targetValue: number | null;
    targetValuePercentage?: number;
    value: number;
    valueColor: string;
    valueProgressBarData: BarData[];
    vsBudgetText?: string;
    vsForecastText?: string;
    vsReferencePeriodText?: string;
  };
}

const HotelAndMarketRevenueInsightSegmentationSegmentationItemWithChange =
  <template>
    <div class="current-value {{if @hasTarget 'current-value--target'}}">
      <HotelAndMarketRevenueInsightSegmentationSegmentationItemCurrentValue
        @activateSearch={{@activateSearch}}
        @isStriped={{@isStriped}}
        @item={{@item}}
        @targetValue={{@targetValue}}
        @targetValuePercentage={{@targetValuePercentage}}
        @value={{@value}}
        @valueProgressBarData={{@valueProgressBarData}}
      />
    </div>
    <div class="reference-value {{if @hasTarget 'reference-value--target'}}">
      {{#if @hasTarget}}
        {{#if @isBudgetActive}}
          <div class="reference-value__title">{{@vsBudgetText}}</div>
        {{else if @isForecastActive}}
          <div class="reference-value__title">{{@vsForecastText}}</div>
        {{else}}
          <div class="reference-value__title">{{@vsReferencePeriodText}}</div>
        {{/if}}
        <div
          data-test-id="reference-value-target"
          style={{@valueColor}}
        >{{@changeData.formattedValue}}</div>
      {{else}}
        {{#if @item.isAggregatedRow}}
          <div
            class="text-200--bold title-and-value-container progress-bar-value flex justify-end
              {{if (gt @changeData.value 0) 'text-success-default'}}
              {{if (lt @changeData.value 0) 'text-critical-default'}}"
          >
            {{@changeData.formattedValue}}
          </div>
        {{else}}
          <PrismDataBar @data={{@changeData}} @type="symmetric" />
        {{/if}}
      {{/if}}
    </div>
  </template> satisfies TOC<HotelAndMarketRevenueInsightSegmentationSegmentationItemWithChangeSignature>;

export default HotelAndMarketRevenueInsightSegmentationSegmentationItemWithChange;
